var _require = require('prettier/standalone'),
    _require$doc$builders = _require.doc.builders,
    concat = _require$doc$builders.concat,
    group = _require$doc$builders.group,
    indent = _require$doc$builders.indent,
    join = _require$doc$builders.join,
    line = _require$doc$builders.line,
    softline = _require$doc$builders.softline;

var modifierArguments = function modifierArguments(node, path, print) {
  if (node.arguments) {
    if (node.arguments.length > 0) {
      return group(concat(['(', indent(concat([softline, join(concat([',', line]), path.map(print, 'arguments'))])), softline, ')']));
    }

    return '()';
  }

  return '';
};

var ModifierInvocation = {
  print: function print(_ref) {
    var node = _ref.node,
        path = _ref.path,
        _print = _ref.print;
    return concat([node.name, modifierArguments(node, path, _print)]);
  }
};
module.exports = ModifierInvocation;